import { FunctionComponent } from "react";

import { faChevronRight, faEnvelope, faTicket } from "@fortawesome/pro-regular-svg-icons";

import { Modal } from "@/components";
import { Icon } from "@/components/Icon/Icon";

interface CampaignBranchModalProps {
	isOpened: boolean;
	onClose: () => void;
	onChooseEvent: () => void;
	onChooseRegular: () => void;
}

interface BranchOption {
	icon: typeof faTicket;
	title: string;
	description: string;
	onClick: () => void;
}

/**
 * Asks whether a new campaign belongs to an event before creating it (PREC-3520). Only shown when
 * the list's event outreach is OFF — when it's already on, creation skips straight to the builder.
 */
export const CampaignBranchModal: FunctionComponent<CampaignBranchModalProps> = ({
	isOpened,
	onClose,
	onChooseEvent,
	onChooseRegular,
}) => {
	const options: BranchOption[] = [
		{
			icon: faTicket,
			title: "Event outreach",
			description: "A trade show, conference, webinar or your own event — anything date-bound.",
			onClick: onChooseEvent,
		},
		{
			icon: faEnvelope,
			title: "Regular outreach",
			description: "Ongoing prospecting with no fixed end date.",
			onClick: onChooseRegular,
		},
	];

	return (
		<Modal
			handleClose={onClose}
			isOpened={isOpened}
			subtitle="This sets up the right defaults before you start writing."
			title="What kind of campaign is this?"
		>
			<div className="flex flex-col gap-3">
				{options.map((option) => (
					<button
						key={option.title}
						className="flex items-center gap-4 rounded-xl border border-border-light p-4 text-left hover:border-blue-action-400 hover:bg-blue-action-200"
						type="button"
						onClick={option.onClick}
					>
						<span className="flex h-10 w-10 items-center justify-center rounded-lg bg-action-200 text-brand-light">
							<Icon icon={option.icon} size="lg" />
						</span>
						<span className="flex-1">
							<span className="block text-sm font-semibold text-gray-900">{option.title}</span>
							<span className="block text-xs text-gray-500">{option.description}</span>
						</span>
						<Icon className="text-gray-400" icon={faChevronRight} />
					</button>
				))}
			</div>
		</Modal>
	);
};
